import { AnnotationType } from '../../../models/annotation.types';

export const getAnnotationTypeLabel = (type: AnnotationType): string => {
  switch (type) {
    case AnnotationType.dynamic:
      return 'Dynamiczna';
    case AnnotationType.static:
      return 'Statyczna';
    default:
      return '???';
  }
};

export const getAnnotationStatusLabel = (active: boolean): string => {
  return active ? 'Aktywna' : 'Nieaktywna';
};
